import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert, Checkbox} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange, handleCheckboxChange } from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: '',
            hour: '',
            minute: '',
            device: '',
            country: null,
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(type) {
        const isValid = this.validateForm();
        const filters = Object.assign({}, this.state);

        if(isValid) this.props.onSubmit(type, filters);
    }

    validateForm() {
        const { day } = this.state;

        let alert = null;

        if(!day) alert = 'Please set Day';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="day"
                            label="Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hour"
                            label="Hour:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hour}
                        />
                    </Col>
                    <Col lg={2}>
                        <SelectWrap
                            values={[ 0, 15, 30, 45 ]}
                            label="Minute:"
                            name="minute"
                            onChange={this.handleFieldChange}
                            value={this.state.minute}
                            required
                        />
                    </Col>
                    <Col lg={2}>
                        <SelectWrap
                            values={{ m: 'Mobile', d: 'Desktop' }}
                            label="Device:"
                            name="device"
                            onChange={this.handleFieldChange}
                            value={this.state.device}
                        />
                    </Col>
                    <Col lg={2}>
                        <SelectWrap
                            values={this.props.browsers}
                            label="Browser:"
                            name="browser"
                            onChange={this.handleFieldChange}
                            value={this.state.browser}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                            required
                        />
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit()}>Load</Button>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit('browser')}>Load Browsers</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderBids/components/Form/index.js